import Vue from 'vue';
import Vuex from 'vuex';
import modules from 'src/store/modules';
import { NODE_ENV } from 'src/config';

Vue.use(Vuex);

const debug = NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules,
  strict: debug,
});

window.$store = store;

export default store;
